// ./src/components/features/Dashboard/DashboardOnboarding.tsx
import React from "react";
import {
  Paper,
  Title,
  Text,
  Group,
  Progress,
  Stack,
  Badge,
  ThemeIcon,
} from "@mantine/core";

import { AppButton, AppIcon } from "@/components/generic";
import { DashboardOnboarding as DashboardOnboardingType } from "@/utils/api";

export interface DashboardOnboardingProps {
  onboarding: DashboardOnboardingType;
  onNavigateToForms: () => void;
}

export const DashboardOnboarding: React.FC<DashboardOnboardingProps> = ({
  onboarding,
  onNavigateToForms,
}) => {
  const steps = [
    {
      key: "hasCreatedForm",
      label: "Create your first form",
      done: onboarding.hasCreatedForm,
    },
    {
      key: "hasConfiguredFields",
      label: "Add validation fields",
      done: onboarding.hasConfiguredFields,
    },
    {
      key: "hasConfiguredEmail",
      label: "Set up email notifications",
      done: onboarding.hasConfiguredEmail,
    },
    {
      key: "hasReceivedSubmission",
      label: "Receive your first submission",
      done: onboarding.hasReceivedSubmission,
    },
    {
      key: "hasConfiguredIntegration",
      label: "Connect a webhook or integration",
      done: onboarding.hasConfiguredIntegration,
    },
  ];

  return (
    <Paper p="md" radius="md" withBorder>
      <Group justify="space-between" mb="md">
        <Group gap="sm">
          <Title order={4} size="h5">
            Getting Started
          </Title>
          <Badge variant="light" size="sm">
            {onboarding.completionPercent}% complete
          </Badge>
        </Group>
        <AppButton variant="secondary" size="xs" onClick={onNavigateToForms}>
          Go to Forms
        </AppButton>
      </Group>

      <Progress
        value={onboarding.completionPercent}
        size="sm"
        radius="xl"
        mb="md"
      />

      <Stack gap="xs">
        {steps.map((step) => (
          <Group key={step.key} gap="sm">
            <ThemeIcon
              size="sm"
              radius="xl"
              color={step.done ? "green" : "gray"}
              variant={step.done ? "filled" : "light"}
            >
              <AppIcon iconName={step.done ? "Check" : "Circle"} size={12} />
            </ThemeIcon>
            <Text
              size="sm"
              c={step.done ? "dimmed" : undefined}
              td={step.done ? "line-through" : undefined}
            >
              {step.label}
            </Text>
          </Group>
        ))}
      </Stack>
    </Paper>
  );
};
